import React from 'react'
import styled from 'styled-components'
import { PageType } from '../../interfaces/types'
import ManifestoCard from './ManifestoCard'

import title from './title.svg'

const StyledDiv = styled.div`
  padding: 58px 10% 0 10%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
`


const ManifestoList = (props: {
  setCurrentPage: (page: PageType, path?: string) => void;
}) => {
  return (
    <>
    <StyledDiv>
      <img src={title} alt="산책도시를 위한 공약 리스트" />
     
    </StyledDiv>
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '15px',
      width: '100%',
      padding: '1em',
      boxSizing: 'border-box',
      justifyContent: 'center',
      alignItems: 'center',
    }}>
    <ManifestoCard
      setCurrentPage={props.setCurrentPage}
        data = {{
          img: 'handshake',
          title: "친절한 성남",
          tags: [
            "15분버스", "판교주3일출근제", "창업가의마을", "테크인턴십"
          ]
        }}
      ></ManifestoCard>
      <ManifestoCard
        setCurrentPage={props.setCurrentPage}
        data = {{
          img: 'leaf',
          title: "여유로운 성남",
          tags: [
            "정책비서", "공공편의시설", "어르신동행바우처", "장애인콜택시"
          ]
        }}
      ></ManifestoCard>
      <ManifestoCard
        setCurrentPage={props.setCurrentPage}
        data = {{
          img: 'shield',
          title: "안전한 성남",
          tags: [
            "직장내괴롭힘", "피해자조력활동가", "참여형지도", "깨끗한우리동네"
          ]
        }}
      ></ManifestoCard>
      
    </div>
    </>
  )
}

export default ManifestoList